const HubConfigInit = (element) => {

    const config = element.querySelector('.js-hub-config');

    if (!config) {
        return;
    }

    const hubConfig = window.hubConfig || {};
    hubConfig.baseUrl = config.dataset.baseUrl;
    hubConfig.loginUrl = config.dataset.loginUrl;
    hubConfig.defaultUrl = config.dataset.defaultUrl;
    hubConfig.defaultMemberUrl = config.dataset.defaultMemberUrl;
    hubConfig.registerUrl = config.dataset.registerUrl;
    hubConfig.mediasiteUrl = config.dataset.mediasiteUrl;
    hubConfig.epostersUrl = config.dataset.epostersUrl;
    hubConfig.loginCookieExpires = config.dataset.loginCookieExpires;
    hubConfig.loginUrlParam = config.dataset.loginUrlParam;
    hubConfig.apiId = config.dataset.apiId;

    //update the hubConfig in the global context
    window.hubConfig = hubConfig;
};

export default HubConfigInit;


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Config/index.js